import { useTranslation } from 'next-i18next';

import { QaCardProps } from '../QaCard';

const useQaList = () => {
  const { t } = useTranslation('faq');

  const qaList: QaCardProps[] = [
    {
      title: t('常见问题'),
      imagePosition: 'right',
      imageUrl: '/images/faq/faq-list-1.png',
      faqItems: [
        {
          key: 'faq-1',
          question: t('faq-1-question'),
          answer: t('faq-1-answer'),
        },
        {
          key: 'faq-2',
          question: t('faq-2-question'),
          answer: t('faq-2-answer'),
        },
        {
          key: 'faq-3',
          question: t('faq-3-question'),
          answer: t('faq-3-answer'),
        },
        {
          key: 'faq-4',
          question: t('faq-4-question'),
          answer: t('faq-4-answer'),
        },
        {
          key: 'faq-5',
          question: t('faq-5-question'),
          answer: t('faq-5-answer'),
        },
        {
          key: 'faq-6',
          question: t('faq-6-question'),
          answer: t('faq-6-answer'),
        },
        {
          key: 'faq-7',
          question: t('faq-7-question'),
          answer: t('faq-7-answer'),
        },
        {
          key: 'faq-8',
          question: t('faq-8-question'),
          answer: t('faq-8-answer'),
        },
      ],
    },
    {
      title: t('国际中文'),
      imagePosition: 'left',
      imageUrl: '/images/faq/faq-list-2.png',
      faqItems: [
        {
          key: 'chinese-faq-1',
          question: t('Chinese-faq-1-question'),
          answer: t('Chinese-faq-1-answer'),
        },
        {
          key: 'chinese-faq-2',
          question: t('Chinese-faq-2-question'),
          answer: t('Chinese-faq-2-answer'),
        },
        {
          key: 'chinese-faq-3',
          question: t('Chinese-faq-3-question'),
          answer: t('Chinese-faq-3-answer'),
        },
      ],
    },
    {
      title: t('国际数学'),
      imagePosition: 'right',
      imageUrl: '/images/faq/faq-list-3.png',
      faqItems: [
        {
          key: 'math-faq-1',
          question: t('math-faq-1-question'),
          answer: t('math-faq-1-answer'),
        },
        {
          key: 'math-faq-2',
          question: t('math-faq-2-question'),
          answer: t('math-faq-2-answer'),
        },
        {
          key: 'math-faq-3',
          question: t('math-faq-3-question'),
          answer: t('math-faq-3-answer'),
        },
        {
          key: 'math-faq-4',
          question: t('math-faq-4-question'),
          answer: t('math-faq-4-answer'),
        },
      ],
    },
    {
      title: t('英文阅读写作'),
      imagePosition: 'left',
      imageUrl: '/images/faq/faq-list-4.png',
      faqItems: [
        {
          key: 'english-faq-1',
          question: t('english-faq-1-question'),
          answer: t('english-faq-1-answer'),
        },
        {
          key: 'english-faq-2',
          question: t('english-faq-2-question'),
          answer: t('english-faq-2-answer'),
        },
        {
          key: 'english-faq-3',
          question: t('english-faq-3-question'),
          answer: t('english-faq-3-answer'),
        },
        {
          key: 'english-faq-4',
          question: t('english-faq-4-question'),
          answer: t('english-faq-4-answer'),
        },
      ],
    },
  ];

  const faqList = [
    {
      key: 'faq-1',
      question: t('faq-1-question'),
      answer: t('faq-1-answer'),
    },
    {
      key: 'faq-2',
      question: t('faq-2-question'),
      answer: t('faq-2-answer'),
    },
    {
      key: 'faq-3',
      question: t('faq-3-question'),
      answer: t('faq-3-answer'),
    },
    {
      key: 'faq-4',
      question: t('faq-4-question'),
      answer: t('faq-4-answer'),
    },
    {
      key: 'faq-5',
      question: t('faq-5-question'),
      answer: t('faq-5-answer'),
    },
    {
      key: 'faq-6',
      question: t('faq-6-question'),
      answer: t('faq-6-answer'),
    },
    {
      key: 'faq-7',
      question: t('faq-7-question'),
      answer: t('faq-7-answer'),
    },
    {
      key: 'faq-8',
      question: t('faq-8-question'),
      answer: t('faq-8-answer'),
    },
    {
      key: 'chinese-faq-1',
      question: t('Chinese-faq-1-question'),
      answer: t('Chinese-faq-1-answer'),
    },
    {
      key: 'chinese-faq-2',
      question: t('Chinese-faq-2-question'),
      answer: t('Chinese-faq-2-answer'),
    },
    {
      key: 'chinese-faq-3',
      question: t('Chinese-faq-3-question'),
      answer: t('Chinese-faq-3-answer'),
    },
    {
      key: 'math-faq-1',
      question: t('math-faq-1-question'),
      answer: t('math-faq-1-answer'),
    },
    {
      key: 'math-faq-2',
      question: t('math-faq-2-question'),
      answer: t('math-faq-2-answer'),
    },
    {
      key: 'math-faq-3',
      question: t('math-faq-3-question'),
      answer: t('math-faq-3-answer'),
    },
    {
      key: 'math-faq-4',
      question: t('math-faq-4-question'),
      answer: t('math-faq-4-answer'),
    },
    {
      key: 'english-faq-1',
      question: t('english-faq-1-question'),
      answer: t('english-faq-1-answer'),
    },
    {
      key: 'english-faq-2',
      question: t('english-faq-2-question'),
      answer: t('english-faq-2-answer'),
    },
    {
      key: 'english-faq-3',
      question: t('english-faq-3-question'),
      answer: t('english-faq-3-answer'),
    },
    {
      key: 'english-faq-4',
      question: t('english-faq-4-question'),
      answer: t('english-faq-4-answer'),
    },
  ];

  return {
    qaList,
    faqList,
  };
};

export default useQaList;
